import { alpha, IconButton, styled } from '@mui/material'
import Backdrop from '@mui/material/Backdrop'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { FC, useEffect, useState } from 'react'
import { FileUploader } from 'react-drag-drop-files'
import { useParams } from 'react-router-dom'
import ArrowDownIcon from '../../../../assets/icons/ArrowDown.svg?react'
import PlusIcon from '../../../../assets/icons/Plus.svg'
import { REQUEST_FILE_TYPES } from '../../../../constants/constants'
import { useDocumentDragState } from '../../../../hooks/useDocumentDragState'
import { useFilesStore } from '../../../../store/storeFiles'
import { useWrapperStore } from '../../../../store/storeWrapper'

interface Props {
    idEntity?: string
    isProject?: boolean
}

const DropZoneInfo = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    padding: 24,
    borderRadius: 24,
    border: '1px solid #E7E8EE',
    background: '#fff',
    height: 196,
    flexBasis: 398,
}))

export const FileUploaderButton: FC<Props> = ({ idEntity, isProject = false }) => {
    const [error, setError] = useState<string>(null)
    const { isDragging, onDrop } = useDocumentDragState()
    const params = useParams()

    const {
        uploadFiles,
        isLoadingUploadFiles,
        setStateNotification,
        errorUploadFiles,
        isDoneUploadFiles,
        setIsDoneUploadFiles,
    } = useWrapperStore((state) => state)
    const { filesUser, fetchFilesUser } = useFilesStore((state) => state)

    const handleChangeFiles = async (files) => {
        if (files.length + filesUser.length > 20) {
            setStateNotification({
                isOpen: true,
                text: 'Доступна загрузка не более 20 файлов во вложениях запроса',
                isError: true,
            })
        } else {
            await uploadFiles({ files }, idEntity)
            await fetchFilesUser({ prefix: `/${idEntity}/` })
        }
    }
    useEffect(() => {
        const text = error || errorUploadFiles
        if (text) {
            setStateNotification({ isOpen: true, text: text, isError: true })
        }
    }, [error, errorUploadFiles])

    useEffect(() => {
        if (isDoneUploadFiles) {
            setStateNotification({
                isOpen: true,
                text: 'Добавление успешно выполнено!',
                isError: false,
            })
            setIsDoneUploadFiles(false)
        }
    }, [isDoneUploadFiles])

    const handleAddFiles = () => {
        document.getElementById('file-uploader-attach-context')?.click()
    }

    const handleTypeError = () => {
        onDrop()
        setError('Данные типы файлов не поддерживаются ARHIASSISTANT')
    }

    const handleSizeError = () => {
        onDrop()
        setError('Размер файла должен быть не больше 10Мб')
    }

    const handleDraggingStateChange = (dragging: boolean) => {
        if (!dragging) {
            onDrop()
        }
    }

    return (
        <>
            <Backdrop
                open={isDragging}
                sx={{
                    position: 'absolute',
                    backgroundColor: alpha('#fff', 0.85),
                    zIndex: 1001,
                }}>
                <FileUploader
                    classes="file-uploader-attach-context"
                    disabled={isLoadingUploadFiles}
                    onSizeError={handleSizeError}
                    onTypeError={handleTypeError}
                    onDraggingStateChange={handleDraggingStateChange}
                    onDrop={onDrop}
                    maxSize={params.requestId ? 10 : null}
                    multiple={true}
                    types={REQUEST_FILE_TYPES}
                    handleChange={handleChangeFiles}
                    name="file-uploader-attach-context"
                    dropMessageStyle={{ display: 'none' }}>
                    <DropZoneInfo>
                        <ArrowDownIcon />
                        <Typography
                            variant="caption"
                            color="textPrimary"
                            fontWeight={500}
                            textAlign="center">
                            Перетяните файл в эту область
                        </Typography>
                    </DropZoneInfo>
                </FileUploader>
            </Backdrop>
            {isProject ? (
                <Tooltip title="Добавить файл в формате: DOC, DOCX, TXT, PDF, PPT, PPTX, XLS, XLSX, JPEG, JPG, PNG, BMP, WEBP">
                    <IconButton
                        disabled={isLoadingUploadFiles}
                        onClick={handleAddFiles}
                        sx={{
                            backgroundColor: '#F9FAFB',
                            padding: '8px',
                        }}
                        size="small">
                        <PlusIcon />
                    </IconButton>
                </Tooltip>
            ) : (
                <Button
                    disabled={isLoadingUploadFiles}
                    onClick={handleAddFiles}
                    startIcon={<PlusIcon />}
                    variant="contained"
                    color="primary"
                    sx={{
                        display: 'flex',
                        my: 0,
                        zIndex: 1000,
                    }}>
                    Добавить
                </Button>
            )}
        </>
    )
}
